/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetUiAccountsBalances200,
  GetUiAccountsBalancesParams,
  UiListAccounts200,
  UiListAccountsParams
} from './schema'



/**
 * Retrieves the balances of account(s).
 * @summary Get Ui Balances
 */
export const getUiAccountsBalances = (
    params?: GetUiAccountsBalancesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUiAccountsBalances200>> => {
    return axios.get(
      `/ui/accounts/balances`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetUiAccountsBalancesQueryKey = (params?: GetUiAccountsBalancesParams,) => [`/ui/accounts/balances`, ...(params ? [params]: [])];

    
export type GetUiAccountsBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof getUiAccountsBalances>>>
export type GetUiAccountsBalancesQueryError = AxiosError<unknown>

export const useGetUiAccountsBalances = <TData = Awaited<ReturnType<typeof getUiAccountsBalances>>, TError = AxiosError<unknown>>(
 params?: GetUiAccountsBalancesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUiAccountsBalances>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUiAccountsBalancesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUiAccountsBalances>>> = ({ signal }) => getUiAccountsBalances(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getUiAccountsBalances>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get a collection of Accounts based on provided search criteria.
 * @summary Get Ui Accounts
 */
export const uiListAccounts = (
    params?: UiListAccountsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UiListAccounts200>> => {
    return axios.get(
      `/ui/accounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUiListAccountsQueryKey = (params?: UiListAccountsParams,) => [`/ui/accounts`, ...(params ? [params]: [])];

    
export type UiListAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof uiListAccounts>>>
export type UiListAccountsQueryError = AxiosError<unknown>

export const useUiListAccounts = <TData = Awaited<ReturnType<typeof uiListAccounts>>, TError = AxiosError<unknown>>(
 params?: UiListAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof uiListAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUiListAccountsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof uiListAccounts>>> = ({ signal }) => uiListAccounts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof uiListAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

